import React from 'react';

import BasePane from '@totem/components/BasePane';
import EndOfLifeContainer, {
  containerConfiguration,
} from '@totem/components/endoflife/EndOfLifeContainer';
import EndOfLifeHeader from '@totem/components/endoflife/EndOfLifeHeader';
import EndOfLifeTable from '@totem/components/endoflife/EndOfLifeTable';
import CardBody from '@totem/components/ui_components/cards/CardBody';
import CardHeader from '@totem/components/ui_components/cards/CardHeader';
import ContentLayout from '@totem/components/ui_components/page/ContentLayout';
import PrimaryContentPane from '@totem/components/ui_components/page/PrimaryContentPane';
import InputContainer from '@totem/components/ui_components/reportSettings/InputContainer';

import './endOfLife.css';

const EndOfLifePage = () => {
  return (
    <ContentLayout>
      <InputContainer
        filterConfig={containerConfiguration}
        defaultSort={{ field: 'productType', direction: 'ascend' }}
        componentKey={'dashboard.endOfLife.products'}
      >
        <EndOfLifeContainer>
          <div styleName="widget-panel">
            <BasePane>
              <PrimaryContentPane>
                <CardHeader>
                  <div>Product End-of-Life</div>
                  <EndOfLifeHeader />
                </CardHeader>
                <CardBody>
                  <EndOfLifeTable />
                </CardBody>
              </PrimaryContentPane>
            </BasePane>
          </div>
        </EndOfLifeContainer>
      </InputContainer>
    </ContentLayout>
  );
};

export default EndOfLifePage;
